/* eslint eol-last: 'off', block-spacing: 'off', brace-style: 'off' */
import common from '@/scripts/common';
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import current from '@/scripts/current';
import commonModelHelper from '@/scripts/commonModelHelper';
import crossTabBuilder from './crossTabBuilder';

export default {
    build,
    getCiTitle,
    getSeTitle
}

function build(apiResults) {
    var rowVariable = current.selectionModel.v.row.getVariableName();
    var columnVariable = current.selectionModel.v.column.getVariableName();
    var control1Variable = current.selectionModel.v.control1.getVariableName();
    var control2Variable = current.selectionModel.v.control2.getVariableName();
    var statistics = current.selectionModel.selectedStatistics;
    var parms = {
        columnIsSpecified: current.selectionModel.v.column.include,
        includeNonResponse: statistics.nonResponse,
        rowVariable: rowVariable,
        row: variableSelectionHelper.getVariableWithGroupAndCategories(apiResults, 'row', 1, rowVariable),
        columnVariable: columnVariable,
        column: variableSelectionHelper.getVariableWithGroupAndCategories(apiResults, 'column', 1, columnVariable),
        control1Variable: control1Variable,
        control1: variableSelectionHelper.getVariableWithGroupAndCategories(apiResults, 'control', 1, control1Variable),
        control2Variable: control2Variable,
        control2: variableSelectionHelper.getVariableWithGroupAndCategories(apiResults, 'control', 2, control2Variable),
        showChiSquare: statistics.chiSquare,
        showCi: statistics.confidenceInterval,
        showSe: statistics.standardError
    };
    var usedStatistics = getStatisticDefinitions();
    if (apiResults.chiSquares === undefined || apiResults.chiSquares === null)
        parms.showChiSquare = 0;
    let ciMultipler = current.selectionModel.selectedStatistics.confidenceInterval ? 1 : 0;
    let seMultipler = current.selectionModel.selectedStatistics.standardError ? 1 : 0;
    let columnsPerStatistic = 1 + ciMultipler + seMultipler;
    var reportModel = {
        parms: parms,
        recordTotals: apiResults.recordTotals,
        usedStatistics: usedStatistics,
        totalNumberOfStatistics: getTotalNumberOfStatistics(usedStatistics, ciMultipler, seMultipler),
        columnsPerStatistic
    };
    var combinedTables = createCombinedTables(apiResults.crossTabulations, apiResults.chiSquares, parms);
    reportModel.levelsGroupedByControl1 = mapControls1(combinedTables, parms);
    reportModel.totalControl1 = reportModel.levelsGroupedByControl1[0];
    reportModel.body = reportModel.levelsGroupedByControl1.filter(l => l.control1Level && l.control1Level.id > 0);
    reportModel.totalControl2 = reportModel.totalControl1.levelsGroupedByControl2[0];
    reportModel.missingData = commonModelHelper.getMissingData(
        [parms.row, parms.column, parms.control1, parms.control2]);

    return reportModel;
}

function getTotalNumberOfStatistics(statistics, ciMultipler, seMultipler) {
    var numberOfStatistics = 0;
    for (var i = 0; i < statistics.length; ++i) {
        numberOfStatistics += (1 +
            (statistics[i].ci === null ? 0 : ciMultipler) +
            (statistics[i].se === null ? 0 : seMultipler));
    }
    return numberOfStatistics;
}

function createCombinedTables(apiCrossTabulations, chiSquares, parms) {
    if (apiCrossTabulations === undefined || apiCrossTabulations === null) {
        var results = chiSquares.map(cs => ({
            control1Level: cs.control1Level,
            control2Level: cs.control2Level,
            chiSquare: cs
        }));
        return results;
    }
    else if (chiSquares === undefined || chiSquares === null) {
        return apiCrossTabulations;
    }
    else {
        var results2 = apiCrossTabulations.map(ct => {
            ct.chiSquare = findChiSquare(chiSquares, ct.controlVariable1.level, ct.controlVariable2.level, parms);
            return ct;
        });
        return results2;
    }
}


// mapRecordTotals: function (recordTotals, parms) {
//     return {
//         numberOfRecords: recordTotals.numberOfRecords,
//         numberOfRecordsExcluded: recordTotals.numberOfRecordsExcluded,
//         numberOfRecordsUsed: recordTotals.numberOfRecordsUsed,
//         n: recordTotals.n,
//         weightedN: recordTotals.weightedN
//     };
// }

function mapControls1(apiCrossTabulations, parms) {
    var crosstabTableGroups = common.groupBy(apiCrossTabulations, 'controlVariable1', 'level');
    var results = crosstabTableGroups.map(r => mapControl1(r, parms));
    results = crossTabBuilder.orderLevels(results, 'control1Level');
    return results;
}

function mapControl1(apiCrossTabulationsForSameControl1, parms) {
    var control1Level = apiCrossTabulationsForSameControl1[0].controlVariable1.level;
    var formattedChildren = mapControls2(apiCrossTabulationsForSameControl1, parms);
    var control = {
        control1Level: crossTabBuilder.getCategory(parms.control1, control1Level, 'Total'),
        levelsGroupedByControl2: formattedChildren,
        body: formattedChildren.map(c => c.control2Level && c.control2Level.id > 0)
    };
    //console.log('control', control);
    return control;
}

function mapControls2(apiCrossTabulationsForSameControl1, parms) {
    //Don't need group by for control2Level as it is already grouped
    //var rowGroups = common.groupBy(records, 'control2Level');
    var results = apiCrossTabulationsForSameControl1.map(r => crossTabBuilder.map(r, parms));
    return crossTabBuilder.orderLevels(results, 'control2Level');
}

function findChiSquare(chiSquares, control1Level, control2Level, parms) {
    var matchingChiSquares = chiSquares.filter(c => {
        var itMatches = true;
        if (parms.control1Variable != null)
            itMatches = itMatches && c.controlVariable1.level === control1Level;
        if (parms.control2Variable != null)
            itMatches = itMatches && c.controlVariable2.level === control2Level;
        return itMatches;
    });
    return matchingChiSquares.length === 0 ? null : matchingChiSquares[0];
}



// mapColumnValues: function (groupedPivotedStatistics, parms) {
//     const l = this;
//     var rowTotal = null;
//     var levelsOfPivotedStatistics = [];
//     groupedPivotedStatistics.forEach(p => {
//         if (p.columnLevel === 0)
//             rowTotal = p;
//         else
//             levelsOfPivotedStatistics.push(p);
//     });
//     return {
//         statistic: groupedPivotedStatistics[0],
//         levels: levelsOfPivotedStatistics.map(g => mapColumnValue(g, parms)),
//         rowTotal: rowTotal == null ? null : mapColumnValue(rowTotal, parms)
//     };
// },
// mapColumnValue: function (pivotedStatistic, parms) {
//     return {
//         columnLevel: getCategory(parms.column, pivotedStatistic.columnLevel, 'Total'),
//         value: pivotedStatistic.value
//     };
// },





function getStatisticDefinitions() {
    var statistics = current.selectionModel.selectedStatistics;
    var theStatistics = [];
    if (statistics.sampleSize)
        theStatistics.push(createStatistic('sampleSize', 'nsum', 'Sample Size'));
    if (statistics.rowPercentage)
        theStatistics.push(createStatistic('rowPercentage', 'rowper', 'Row %', statistics.standardError, 'serow', statistics.confidenceInterval, 'cirow'));
    if (statistics.columnPercentage)
        theStatistics.push(createStatistic('columnPercentage', 'colper', 'Column %', statistics.standardError, 'secol', statistics.confidenceInterval, 'cicol'));
    if (statistics.totalPercentage)
        theStatistics.push(createStatistic('totalPercentage', 'totper', 'Total % (Weighted)', statistics.standardError, 'setot', statistics.confidenceInterval, 'citot'));
    if (statistics.weightedN)
        theStatistics.push(createStatistic('weightedN', 'wsum', 'Weighted N', statistics.standardError, 'sewgt', statistics.confidenceInterval, 'ciwgt'));


    return theStatistics;
}

function createStatistic(apiName, apiName2, label, seFlag, seApiName, ciFlag, ciApiName) {
    var statistic = {
        apiName: apiName,
        name: apiName2,
        label: label,
        se: null,
        ci: null
    };
    if (seFlag) {
        statistic.se = {
            name: seApiName,
            label: getSeTitle(apiName)
        };
    }
    if (ciFlag !== undefined && ciFlag !== null && ciFlag !== 0) {
        statistic.ci = {
            name: ciApiName,
            label: getCiTitle(apiName)
        };
    }
    return statistic;
}

function getCiTitle(statistic) {
    switch (statistic) {
        case 'rowPercentage':
            return '95% CI (Row %)';
        case 'columnPercentage':
            return '95% CI (Column %)';
        case 'totalPercentage':
            return '95% CI (Total %)';
        case 'weightedN':
            return '95% CI (Weighted N)';
        default:
            return '';
    }
}

function getSeTitle(statistic) {
    switch (statistic) {
        case 'rowPercentage':
            return 'Row % SE';
        case 'columnPercentage':
            return 'Column % SE';
        case 'totalPercentage':
            return 'Total % SE';
        case 'weightedN':
            return 'Weighted N SE';
        default:
            return '';
    }
}

